module.exports = __webpack_public_path__ + "img/requeteur_read.f63bdc33.png";